import React from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { FormComponentProps, ReviewSubmitData } from '../../types/forms';

const ReviewSubmit: React.FC<FormComponentProps<ReviewSubmitData>> = ({ data, onNext }) => {
  const [certified, setCertified] = React.useState(false);
  const [agreedToTerms, setAgreedToTerms] = React.useState(false);

  const handleCertificationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCertified(event.target.checked);
    if (event.target.checked && agreedToTerms) {
      onNext({ currentStep: data?.currentStep || 1 });
    }
  };

  const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAgreedToTerms(event.target.checked);
    if (event.target.checked && certified) {
      onNext({ currentStep: data?.currentStep || 1 });
    }
  };

  return (
    <Box>
      <Typography variant="h3" gutterBottom sx={{ fontWeight: 400 }}>
        Review & Submit
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph sx={{ fontWeight: 400 }}>
        Please review your information before submitting. You can go back to make changes if needed.
      </Typography>

      <Box sx={{ mt: 4 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={certified}
              onChange={handleCertificationChange}
              required
            />
          }
          label={
            <Typography variant="body1">
              I certify that all information provided is accurate and complete{' '}
              <Typography component="span" color="error">
                *
              </Typography>
            </Typography>
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={agreedToTerms}
              onChange={handleTermsChange}
              required
            />
          }
          label={
            <Typography variant="body1">
              I agree to the privacy policy and terms of service{' '}
              <Typography component="span" color="error">
                *
              </Typography>
            </Typography>
          }
        />
      </Box>
    </Box>
  );
};

export default ReviewSubmit; 